import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import {
	CSSZSickLeaveCertificate,
	CSSZUser,
} from '../../Interfaces/CSSZ.interface';
import CSSZSickLeaveCertificateEndOfSickLeave from './CSSZSickLeaveCertificateEndOfSickLeave';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	user: CSSZUser;
	item: CSSZSickLeaveCertificate;
	onCreate: () => void;
}

const CSSZSickLeaveCertificateEndOfSickLeaveModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.CSSZSickLeaveCertificateEndOfSickLeave.modalTitle'
			size={Size.LG}>
			<CSSZSickLeaveCertificateEndOfSickLeave
				item={props.item}
				onCreate={props.onCreate}
				user={props.user}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateEndOfSickLeaveModal;
